import React from 'react';
import { BulkActions } from '../../../../enums/bulk-actions';
import { CustomFieldIds, getAllNoteTypes } from '../../../../services/order-note-service';
import { NoteDropdownAndField } from '../add-note';

const customFieldId = CustomFieldIds.CustomFieldTwo;
const customFieldTypeOption = getAllNoteTypes().find(({ id }) => id === customFieldId);

export default {
  id: BulkActions.customFieldTwo.name,
  render: (onChange, model) => {
    const customFieldToNoteModel = {
      ...model,
      note: {
        ...model.note,
        noteType: customFieldId,
      },
    };
    return <NoteDropdownAndField customFieldTypeOption={customFieldTypeOption} model={customFieldToNoteModel} onChange={onChange} />;
  },
};
